exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gearImg-ff2fd6c6{height:70px;width:70px}\n", ""]);

// Exports
exports.locals = {
	"gearImg": "gearImg-ff2fd6c6"
};